import React from "react"
import { useSelector } from "react-redux"
import { Container } from "reactstrap"
import MemberItem from "../members/MemberItem"
import { connect } from "react-redux"
import StellarLoader from "../layout/StellarLoader"
import PropTypes from "prop-types"

function CashoutErrorList(props) {
  const { isLoading } = useSelector((state) => ({
    isLoading: state.vlsaMembersLoadingStarted,
  }))

  if (isLoading) {
    return <StellarLoader />
  }

  const getMemberByAccountHolderId = (accountHolderId) => {
    return props.loadedvslaMembers.find((member) => member.id === accountHolderId)
  }

  return (
    <div>
      <Container style={{ marginBottom: "140px" }}>
        <ol
          key={props.membersWithLoans.members.length}
          style={{ lineHeight: "0.3" }}
        >
          {props.membersWithLoans.members.map((memberWithLoan) => {
            const fullMemberDetails = getMemberByAccountHolderId(
              memberWithLoan.accountHolderId,
            )
            return (
              memberWithLoan &&
              fullMemberDetails && (
                <MemberItem
                  members={props.membersWithLoans.members}
                  key={memberWithLoan.accountHolderId}
                  member_details={fullMemberDetails}
                  vsla_id={props.id}
                />
              )
            )
          })}
        </ol>
      </Container>
    </div>
  )
}

const mapStateToProps = (state) => ({
  membersWithLoans: state.membersWithLoans,
  id: state.group?.id,
  loadedvslaMembers: state.loadedvslaMembers,
})

CashoutErrorList.propTypes = {
  membersWithLoans: PropTypes.object,
  id: PropTypes.string,
  loadedvslaMembers: PropTypes.array,
}

export default connect(mapStateToProps, null)(CashoutErrorList)
